<template>
  <div>
    <UiSlidePanel ref="slidePanel" />
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { UiSlidePanel } from '~/javascript/components/ui/slide_panel'
import ListForm from './list_form.vue'

const props = defineProps({
  csrfToken: { type: String, required: true },
  createUrl: { type: String, required: true },
  updateUrlBase: { type: String, required: true }
})

const slidePanel = ref(null)

const onSaved = () => {
  slidePanel.value?.close()
  window.location.reload()
}

const openForm = (list) => {
  slidePanel.value?.open({
    component: ListForm,
    props: {
      list,
      csrfToken: props.csrfToken,
      createUrl: props.createUrl,
      updateUrlBase: props.updateUrlBase
    },
    events: { saved: onSaved }
  })
}

const handleNew = () => openForm(null)
const handleEdit = (e) => openForm(e.detail)

onMounted(() => {
  document.addEventListener('negative-keyword-list:new', handleNew)
  document.addEventListener('negative-keyword-list:edit', handleEdit)
})

onBeforeUnmount(() => {
  document.removeEventListener('negative-keyword-list:new', handleNew)
  document.removeEventListener('negative-keyword-list:edit', handleEdit)
})
</script>
